import { useState } from "react";
import { BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { toDisplay } from "../lib/currency";
import { money } from "../lib/format";

export default function ExpenseChart({ data, currency = "TRY", rates = {} }) {
  const [kind, setKind] = useState("expense");
  const rows = (data[kind] || []).map(r => ({ ...r, total: toDisplay(r.total, currency, rates) }));
  const expense = kind === "expense";

  return (
    <section className="panel chart-panel">
      <div className="panel-head">
        <div>
          <p className="eyebrow">{expense ? "GİDER DAĞILIMI" : "GELİR DAĞILIMI"}</p>
          <h3>{expense ? "Hangi grup ne kadar?" : "Hangi kalem ne kadar?"}</h3>
        </div>
        <div className="segmented mini" data-testid="breakdown-kind-toggle">
          <button type="button" data-testid="breakdown-kind-expense" className={expense ? "selected expense-btn" : ""} onClick={() => setKind("expense")}>Gider</button>
          <button type="button" data-testid="breakdown-kind-income" className={!expense ? "selected income-btn" : ""} onClick={() => setKind("income")}>Gelir</button>
        </div>
      </div>
      <div className="chart-wrap" data-testid="expense-chart">
        {rows.length ? (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={rows}>
              <CartesianGrid vertical={false} stroke="#e7edf3"/>
              <XAxis dataKey="group" tickLine={false} axisLine={false} tick={{ fontSize: 11 }}/>
              <YAxis tickLine={false} axisLine={false} tick={{ fontSize: 11 }} tickFormatter={v => new Intl.NumberFormat("tr-TR", { notation: "compact" }).format(v)}/>
              <Tooltip formatter={v => money(v, currency)} cursor={{ fill: "#f5f8fb" }}/>
              <Bar dataKey="total" fill={expense ? "#f59e0b" : "#10b981"} radius={[5, 5, 0, 0]}/>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="empty-chart">{expense ? "Bu ay için gider verisi yok" : "Bu ay için gelir verisi yok"}</div>
        )}
      </div>
    </section>
  );
}
